// components/internalLeftPanel.js
import React, { useEffect, useState } from "react";
import {
    LEGAL_RESEARCH_REQUEST_STATUS,
} from "utils/constantValues";
import InternalProposalDocument from "./internal";
import InternalResearchDraft from "./internalResearchDraft";

function InternalLeftPanel({ request, activeTab }: { request: any, activeTab: string }) {
    const [formState, setFormState] = useState({
        ...request,
    });
    useEffect(() => {
        setFormState({ ...request });
    }, [request]);

    return (
        <div className="flex flex-col flex-1 bg-gray-100 mr-4 rounded-lg">
            {activeTab === "Proposal Document" ?
                <InternalProposalDocument filteredData={request} /> :
                ((formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.research_underway.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.draft_submitted.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.draft_revision.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.draft_approved.value || formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.completed.value || formState?.documents.find((document: any) => document.document_type === "research_draft_file")) && <InternalResearchDraft request={request} />)
            }
        </div>
    );
}

export default InternalLeftPanel;

